/**
 * Private onboarding data (currently user_subscriptions) is protected by
 * Firestore owner rules. The onboarding invite itself is intentionally public
 * so a visitor can start the email-code flow, but private reads must wait until
 * Firebase Auth confirms that the visitor owns the route account.
 */
function canLoadPrivateOnboardingData(inviteId, authenticatedUserId) {
  return (
    typeof inviteId === "string" &&
    inviteId.length > 0 &&
    typeof authenticatedUserId === "string" &&
    authenticatedUserId === inviteId
  );
}

module.exports = {
  canLoadPrivateOnboardingData,
};
